import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig, leasingServiceUrl } from '~/utils/env';
import type { RentalApplicationPaymentBreakdownDto } from '~/swagger/leasing/Api';
import type { RentalApplicationBillingSettings } from '~/swagger/settings/Api';
const RENTAL_APPLICATION_PAYMENT_SETTINGS_URL = `${envConfig.service.settings}/company-portal/settings/rentalapplicationbilling`;
const RENTAL_APPLICATION_PAYMENT_COMPANY_SETTINGS_URL = `${RENTAL_APPLICATION_PAYMENT_SETTINGS_URL}/company`;
const RENTAL_APPLICATION_PAYMENT_SUMMARY_URL = `${leasingServiceUrl()}/company-portal/rental-applications/breakdown`;

export class RentalApplicationPaymentSettingRepository extends BaseRestRepository {
  public async getRentalApplicationPaymentSettings(): Promise<RentalApplicationBillingSettings> {
    const url = RENTAL_APPLICATION_PAYMENT_COMPANY_SETTINGS_URL;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteRentalApplicationPaymentSettings(): Promise<void> {
    return undefined;
  }

  public async updateRentalApplicationPaymentSettings(
    payload: RentalApplicationBillingSettings
  ): Promise<RentalApplicationBillingSettings> {
    const url = RENTAL_APPLICATION_PAYMENT_COMPANY_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getRentalApplicationPaymentSummary(): Promise<RentalApplicationPaymentBreakdownDto> {
    const url = RENTAL_APPLICATION_PAYMENT_SUMMARY_URL;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }
}

export const rentalApplicationPaymentSettingRepository = new RentalApplicationPaymentSettingRepository();
